import { render, staticRenderFns } from "./DetailBag.vue?vue&type=template&id=b1cdae54&"
import script from "./DetailBag.vue?vue&type=script&lang=js&"
export * from "./DetailBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports